<template>
  <div>
    <label class="switch" @click="handleToggle">
      <input type="checkbox" :disabled="disabled" v-model="localChecked" />
      <span class="slider round" :class="{ disabled: disabled }"></span>
    </label>
    <p v-if="toggleText" class="caption2 black-color text-center" v-margin-top=".2">{{toggleText}}</p>
  </div>
</template>

<script>
export default {
  name: 'CpSliceToggle',
  directives: {
    marginTop: require('../directives/margins').marginTop,
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    toggleText: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      localChecked: this.value,
    };
  },
  computed: {
    checked() {
      return this.value;
    },
  },
  methods: {
    handleToggle(event) {
      if (this.disabled) {
        event.preventDefault();
        return;
      }
    },
  },
  watch: {
    value(newValue) {
      this.localChecked = newValue;
    },
    localChecked(newValue) {
      this.$emit('input', newValue);
    },
  },
};
</script>

<style scoped>
.switch {
  position: relative;
  display: inline-block;
  width: 58px;
  height: 28px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--neutral3);
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: '';
  height: 22px;
  width: 22px;
  left: 4px;
  bottom: 3px;
  background-color: var(--white);
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: var(--primary-blue-600);
}

input:focus + .slider {
  box-shadow: 0 0 1px var(--primary-blue-600);
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

.disabled {
  cursor: default;
  opacity: 0.5;
}
</style>
